import { factorySetStateAction } from '../factory'

// Defined Device Constants to bind SAGA functions with Redux Dispatcher
const actions = {
  SET_STATE: 'liveRespiration/SET_STATE',
}

export const liveRespirationSetState = factorySetStateAction(actions.SET_STATE)

export default actions
